// 统一导出所有 API 模块
import * as productApi from './product';
import * as simApi from './sim';
import * as orderApi from './order';
import * as homeApi from './home';
import * as couponApi from './coupon';
import * as deviceApi from './device';

export default {
  product: productApi,
  sim: simApi,
  order: orderApi,
  home: homeApi,
  coupon: couponApi,
  device: deviceApi,
};